import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogType } from '../medi-dialog/medi-dialog.component';
import { OroService } from '../oroservice';

@Component({
    selector: 'app-management',
    templateUrl: './management.component.html',
    styleUrls: ['./management.component.scss'],
    standalone: false
})
export class ManagementComponent implements OnInit {
    public emailColumns: string[] = ['Email', 'AccessType', 'Status', 'Tools'];
    public email : string = "";
    isLoading: boolean = false;

    constructor(public oroservice: OroService, private translate: TranslateService, private datePipe: DatePipe, private _router: Router) { }

    ngOnInit() {
        this.isLoading = true;

        this.oroservice.getKundenInfo().then(
            () => {
                this.isLoading = false;
                if (!this.oroservice.kundeninfo.IsMaster) {
                    this._router.navigate(['Startseite']);
                }
            }
        );
    }

    AddLogin() {
        this.oroservice.setInvite({ email: this.email }).then(
            (object) => {
                if (!object) {
                    this.oroservice.getKundenInfo();
                    this.email = "";
                    this.oroservice.openDialogMessage("Verwaltung.SumbitMessage");
                }
            });
    }

    DeleteLogin(log: any) {
        this.oroservice.openDialog("500px", "Verwaltung.Title", "Verwaltung.RemoveFeedback", "Ja", "Nein", DialogType.Question).subscribe(result => {
            if (result) {
                this.oroservice.deletelogin(log).then((object) => {
                    this.oroservice.getKundenInfo();
                });
            }
        });
    }

    getActivityMessage(n: number): string {
        let result: string;
        switch (n) {
            case 0:
                result = "EmailInactive";
                break;

            case 1:
                result = "EmailActive";
                break;

            case 2:
                result = "EmailExpired";
                break;
        }

        return result;
    }

    getAccessType(master: boolean): string {
        if (master) {
            return "Verwaltung.MasterAccess";
        } else {
            return "Verwaltung.ManagementAccess";
        }
    }

    validateemail(email: string): boolean {
        const regex = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
        return regex.test(email);
    }
}
